<template>
	<div class="component-wrap">

		<AppContentHeader headline="Billing Reports">

		</AppContentHeader>

		<div class="report-container md-gutter">

			<div
				class="report-box md-elevation-15 md-layout-item md-size-30"
				@click="$router.push('/reports/billing/sponsorships')"
			>
				<div class="report-box__info">
					<h3 class="md-subheading"><strong>Sponsorships billing report</strong></h3>
					<h6 class="md-subheading"> Generate Excel spreadsheet to bill for a season of sponsorships.</h6>

					<md-button class="md-raised md-primary">RUN REPORT</md-button>
				</div>

				<md-tooltip md-direction="top">Run reports</md-tooltip>
			</div>

			<div
				class="report-box md-elevation-15 md-layout-item md-size-30"
				@click="$router.push('/reports/billing/signage')"
			>
				<div class="report-box__info">
					<h3 class="md-subheading"><strong>Signage billing report</strong></h3>
					<h6 class="md-subheading"> Generate Excel spreadsheet to bill for a season of operational
						signage.</h6>

					<md-button class="md-raised md-primary">RUN REPORT</md-button>
				</div>

				<md-tooltip md-direction="top">Run reports</md-tooltip>
			</div>


      <div
          class="report-box md-elevation-15 md-layout-item md-size-30"
          @click="$router.push('/reports/billing/budget')"
      >
        <div class="report-box__info">
          <h3 class="md-subheading"><strong>Budget report</strong></h3>
          <h6 class="md-subheading"> Generate Excel spreadsheet of all signage orders.</h6>

          <md-button class="md-raised md-primary">RUN REPORT</md-button>
        </div>

        <md-tooltip md-direction="top">Run reports</md-tooltip>
      </div>
		</div>

	</div>
</template>

<script>

	export default {
		name: 'ReportsDashboardBilling',
		data: function () {
			return {}
		},

		components: {},
	}
</script>

<style lang="scss" scoped>
	.boxes {
		width: 100%;
	}

  .report-container {
    display: flex;
    flex-direction: row;

    @include respond(small) {
      flex-direction: column;
      justify-content: center;
    }
  }

	.report-box {
		display: flex;
		padding: 1.6rem 2.4rem;
		margin-right: 5rem;
		cursor: pointer;
		justify-content: center;
		align-content: center;

		@include respond(small) {
      min-width: 100%;
      margin-bottom: 10px;
			flex-direction: column;
			justify-content: center;
		}

		&__info {
			display: flex;
			flex-direction: column;
			justify-content: center;

			.md-button {
				margin-top: 3rem;
				box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
				border-radius: 4px;
			}
		}

		&__items {
			width: 60%;

			@include respond(small) {
				width: 100%;
			}
		}

		&__list {
			list-style: none;
			padding: 0;

			@include respond(small) {
				margin: 16px 0;
			}
		}

		&__item {
			text-align: right;

			@include respond(small) {
				text-align: left;
			}
		}

		h3, h6 {
			text-align: center;
		}

		h6.md-subheading {
			font-size: 14px;
		}
	}
</style>